import { Component, Input, OnInit } from '@angular/core';
import { CollapseIconPosition } from '../../utils/collapse/collapse-icon-position.enum';
import { Panel } from '../../utils/panel/panel.interface';
import {
  BorderConfig,
  BoxShadowConfig,
  ColorConfig,
  SizeConfig,
  SpacingConfig,
} from '../../utils/shared';

@Component({
  selector: 'rappider-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class RappiderAccordionComponent implements OnInit {
  @Input() panels: Panel[];
  @Input() bordered: boolean;
  @Input() collapseIconPosition: CollapseIconPosition;
  @Input() borderSettings: BorderConfig;
  @Input() sizeSettings: SizeConfig;
  @Input() colorSettings: ColorConfig;
  @Input() boxShadowSettings: BoxShadowConfig;
  @Input() paddingSettings: SpacingConfig;
  @Input() marginSettings: SpacingConfig;

  borderStyles: any = {};

  ngOnInit(): void {
    this.getStyles();
  }

  getStyles(): any {
    // Border settings
    if (this.borderSettings?.border) {
      const borderParts = this.borderSettings.border.split(' ');
      if (borderParts.length === 3) {
        this.borderStyles['border-width'] = borderParts[0];
        this.borderStyles['border-style'] = borderParts[1];
        this.borderStyles['border-color'] = borderParts[2];
      } else {
        delete this.borderStyles['border-width'];
        delete this.borderStyles['border-style'];
        delete this.borderStyles['border-color'];
      }
    } else {
      delete this.borderStyles['border-width'];
      delete this.borderStyles['border-style'];
      delete this.borderStyles['border-color'];
    }

    // Border radius settings
    if (this.borderSettings?.borderRadius) {
      this.borderStyles['border-radius'] = this.borderSettings.borderRadius;
    } else {
      delete this.borderStyles['border-radius'];
    }
  }

}
